import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'white-label-footer-ararity-auctions',
    imports: [],
    templateUrl: './white-label-footer-ararity-auctions.component.html',
    styleUrls: ['./white-label-footer-ararity-auctions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhiteLabelFooterArarityAuctionsComponent {
 public currentYear = new Date().getFullYear();

 }
